import isEmpty from 'lodash/isEmpty';
import { fromJS } from 'immutable';
import { storeGenerator } from '../../utils/Generator';

export default storeGenerator('UserStore', {
  handlers: {
    SET_USERS: 'setUsers',
    SET_ACCOUNT: 'setAccount',
  },

  defaults: {
    users: {},
    account: {},
  },

  setUsers({ users }) {
    let nextUsers = this.get(['users']);
    users.forEach((user) => isEmpty(user) || (nextUsers = nextUsers.mergeDeepIn([user.uid], fromJS(user))));
    this.set(['users'], nextUsers);
  },

  setAccount({ account }) {
    const nextAccount = fromJS(account);
    this.set(['account'], nextAccount);
  },

  getUser({ uid }) {
    return this.get(['users', uid]) || fromJS({});
  },

  getAccount() {
    return this.get(['account']) || fromJS({});
  },
});



// WEBPACK FOOTER //
// ./src/app/stores/User/User.js